import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable, NgModule } from '@angular/core';
import { JsonResourceResponse } from 'app/generated/generated-common';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { CountryTimeZoneLookupModel } from 'app/generated/backend/localization/api/country-time-zone-lookup-model';

@Injectable()
export class CountryTimeZonesHandlerService {
	private handleError(error: Response | any) {
		return throwError(error);
	}
	constructor(private http: HttpClient) { }
	get(
	): Observable<JsonResourceResponse<CountryTimeZoneLookupModel[]>> {
		return this.http.get<JsonResourceResponse<CountryTimeZoneLookupModel[]>>('api/v1/localization/countryTimeZones').pipe(
			map(response => response),
			catchError(this.handleError));
	}
}

@NgModule({
	imports: [
		CommonModule
	],
	providers: [
		CountryTimeZonesHandlerService
	]
})
export class CountryTimeZonesHandlerModule { }
